export default __webpack_public_path__ + "static/og-image_1200x630-f5b30c9ea6171ddb1b999db7cdcdb15c.jpg";